type ExploreSortItem = {
  value: string;
  label: string;
};

type GetRulebookExploreSortItemsArgs = {
  collectionName: string;
  textMatchPrefix: string;
  translate: (key: string, options?: { defaultValue?: string }) => string;
};

/** Sort options for the public Rulebooks index — it has no num_messages_24h or rating_score fields. */
export default function getRulebookExploreSortItems({ collectionName, textMatchPrefix, translate }: GetRulebookExploreSortItemsArgs): ExploreSortItem[] {
  return [
    {
      value: `${collectionName}/sort/${textMatchPrefix},createdAt:desc`,
      label: translate("search:sortBy.latest"),
    },
    {
      value: `${collectionName}/sort/${textMatchPrefix},num_attached_characters:desc`,
      label: translate("search:sortBy.mostAttachedCharacters", { defaultValue: "Most Attached Characters" }),
    },
    {
      value: `${collectionName}/sort/${textMatchPrefix},num_attached_personas:desc`,
      label: translate("search:sortBy.mostAttachedPersonas", { defaultValue: "Most Attached Personas" }),
    },
  ];
}
